import { IQuestionValues } from "../types"

const pickQuestionValues = (obj: IQuestionValues & any): IQuestionValues => {
  const { num_apps, num_joins, num_leaves, num_employees } = obj
  return {
    num_apps,
    num_employees,
    num_joins,
    num_leaves,
  }
}

export { pickQuestionValues }
